"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _UserProfile = _interopRequireDefault(require("MeetingsBase/models/UserProfile"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var FormActions = _interopRequireWildcard(require("MeetingsLib/redux/actions/FormActions"));

var _DatePicker = _interopRequireDefault(require("MeetingsLib/components/schedule/date/DatePicker"));

var _ProfileHeader = _interopRequireDefault(require("MeetingsLib/components/header/ProfileHeader"));

var _ColoredCard = _interopRequireDefault(require("MeetingsLib/components/decorative/ColoredCard"));

var _FreemiumBookingUpgradeLink = _interopRequireDefault(require("MeetingsLib/components/freemium/FreemiumBookingUpgradeLink"));

var DatePickerSection = (0, _createReactClass.default)({
  propTypes: {
    // passed
    avatar: _propTypes.default.string,
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired,
    compact: _propTypes.default.bool,
    embedded: _propTypes.default.bool,
    headline: _propTypes.default.string,
    profile: _propTypes.default.instanceOf(_UserProfile.default).isRequired,
    DatePickerMarker: _propTypes.default.func.isRequired,
    TimePickerMarker: _propTypes.default.func.isRequired,
    // loaded
    isSalesStarter: _propTypes.default.bool,
    setEventDate: _propTypes.default.func.isRequired
  },
  getCardClasses: function getCardClasses() {
    var _this$props = this.props,
        embedded = _this$props.embedded,
        isSalesStarter = _this$props.isSalesStarter;
    return (0, _classnames.default)('p-top-7 p-bottom-5 height-93', {
      'p-top-13': isSalesStarter,
      'm-bottom-0': !isSalesStarter,
      'height-100': embedded || isSalesStarter
    });
  },
  renderFreemiumText: function renderFreemiumText() {
    var isSalesStarter = this.props.isSalesStarter;

    if (isSalesStarter) {
      return null;
    }

    return _react.default.createElement(_FreemiumBookingUpgradeLink.default, null);
  },
  render: function render() {
    var _this$props2 = this.props,
        avatar = _this$props2.avatar,
        branding = _this$props2.branding,
        compact = _this$props2.compact,
        headline = _this$props2.headline,
        profile = _this$props2.profile,
        setEventDate = _this$props2.setEventDate,
        DatePickerMarker = _this$props2.DatePickerMarker,
        TimePickerMarker = _this$props2.TimePickerMarker;
    return _react.default.createElement("div", {
      className: "date-picker-section overflow-y-hidden"
    }, _react.default.createElement(_ColoredCard.default, {
      className: this.getCardClasses(),
      cardSectionClassName: "m-bottom-0 p-all-0",
      branding: branding
    }, _react.default.createElement(_ProfileHeader.default, {
      avatar: avatar,
      booked: false,
      headline: headline,
      profile: profile
    }), _react.default.createElement(_DatePicker.default, {
      compact: compact,
      profile: profile,
      branding: branding,
      setEventDate: setEventDate,
      DatePickerMarker: DatePickerMarker,
      TimePickerMarker: TimePickerMarker
    })), this.renderFreemiumText());
  }
});

var _default = (0, _reactRedux.connect)(function (state) {
  return {
    isSalesStarter: state.isSalesStarter
  };
}, (0, _extends2.default)({}, FormActions))(DatePickerSection);

exports.default = _default;
module.exports = exports.default;